import Vue from 'vue'
import addGlyphs from './fontAwesome'
import BootstrapVue from 'bootstrap-vue'
import { focus } from 'vue-focus'
import cssVars from 'css-vars-ponyfill'
import vuetify from './plugins/vuetify'

import App from './App.vue'
import router from './router'
import store from './store/store'

import OAuth from './plugins/OAuth/OAuth'
import jwtDecode from 'jwt-decode'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import endPoint from './store/endPoint'
import isExpired from './store/helper/isExpired'
import hasNearlyExpired from './store/helper/hasNearlyExpired'
import { HEARTBEAT_EXEMPTIONS, NODE_ENVIRONMENTS } from './constants'
import VueMoment from 'vue-moment'
import VueCurrencyInput from 'vue-currency-input'

const pluginOptions = {
  /* see config reference */
  globalOptions: { currency: 'USD' , locale: 'en', precision: 2,allowNegative: false}
}

const TOKEN_REFRESH_RATE = process.env.VUE_APP_TOKEN_REFRESH_RATE

addGlyphs()

//calling cssVars ponyfill to provide client-side support for CSS custom properties (aka "CSS variables") in legacy and modern browsers.
cssVars({})

Vue.use(BootstrapVue)
Vue.use(require('vue-bootstrap-typeahead'))
Vue.use(require('vue-scrollto')) // Handles scrolling to elements
Vue.use(VueMoment)
Vue.directive('focus', focus) // Adds third party focus directive to handle keyboard focus
Vue.use(VueCurrencyInput, pluginOptions)

Vue.use(OAuth, {
  router,
  authProviderConfig: {  
  },
  appStateToPersist: () => ({
    application: store.state.application,
    isNewApplication: store.state.isNewApplication,
    currentApplication: store.state.currentApplication,
    resumeViaButton: store.state.resumeViaButton
  }),
  storagePrefix: 'pi.auth',
  onAuthorisedRedirect: (tokens, persistedState) => {
    const idDecoded = jwtDecode(tokens.id)

    store.commit('set', [
      'auth',
      {
        ...store.state.auth,
        idToken: tokens.id,
        refreshToken: tokens.refresh,
        idTokenTime: new Date().getTime(),
        userId: idDecoded.email,
        authProvider: persistedState.authProvider
      }
    ])
    store.commit('set', ['application', persistedState.application])
    store.commit('set', [
      'currentApplication',
      persistedState.currentApplication
    ])

    store.commit('set', ['isNewApplication', persistedState.isNewApplication])
    store.commit('set', ['resumeViaButton', persistedState.resumeViaButton])
    
  },
  onRedirectError: error => {
    store.dispatch('set', ['error', error])
    router.history.push('/error')
  }
})


Vue.config.productionTip = false

new Vue({
  router,  
  store,
  vuetify,
  mounted() {
   
  },
  created() {
    window.addEventListener('beforeunload', this.onBeforeUnload)

    this.addListeners()

    window.setInterval(this.heartbeat, TOKEN_REFRESH_RATE)

    //this.$store.dispatch('getOESProperties').catch(() => {}) //Fail silently
  },
  beforeDestroy() {
    this.removeListeners()
  },
  methods: {
    addListeners() {
      document.addEventListener('keydown', this.setActive)
      document.addEventListener('mousedown', this.setActive)
    },
    removeListeners() {
      document.removeEventListener('keydown', this.setActive)
      document.removeEventListener('mousedown', this.setActive)
    },
    setActive() {
      if (!this.$store.state.auth.isUserActive) {
        this.$store.commit('set', ['auth.isUserActive', true])
        this.$store.commit('set', [
          'auth.isUserActiveTime',
          new Date().getTime()
        ])
      }
    },
    heartbeat() {
      // Are we in a view that requires checking?
      if (
        !HEARTBEAT_EXEMPTIONS.find(
          item => item === this.$router.history.current.name
        )
      ) {
        this.checkAuthExpiry()
        this.checkUserActivity()
      }

      // Always reset every `TOKEN_REFRESH_RATE` seconds to "track" activity
      this.$store.commit('set', ['auth.isUserActive', false])
    },
    checkAuthExpiry() {
      // The least amount of auth variables needed to count a user as authenticated
      if (
        !this.$store.state.auth.userId &&
        !this.$store.state.auth.idToken &&
        !this.$store.state.auth.idTokenTime &&
        !this.$store.state.auth.refreshToken
      ) {
        this.$router.history.push('/error')
      }

      // We issue a new token if the user has been active within the last hour
      // (checked by `checkUserActivity()`), and will expire in less than a
      // minute.
      if (hasNearlyExpired(this.$store.state.auth.idTokenTime)) {
        endPoint
          .getAuthRefreshToken(
            this.$store.state.auth.userId,
            this.$store.state.auth.refreshToken
          )
          .then(res => {
            this.$store.commit('set', ['auth.idToken', res.data.body.idToken])
            this.$store.commit('set', [
              'auth.idTokenTime',
              new Date().getTime()
            ])
          })
          .catch(() => {
            this.$store.dispatch('hideSpinner')
            this.$router.history.push('/error?type=500')
          })
      }

      if (isExpired(this.$store.state.auth.idTokenTime)) {
        this.resetState()
        this.$router.history.push('/login/timeout')
      }
    },
    checkUserActivity() {
      if (
        this.$store.state.auth.isUserActive ||
        !this.$store.state.auth.isUserActiveTime
      )
        return

      if (isExpired(this.$store.state.auth.isUserActiveTime)) {
        this.resetState()
        this.$router.history.push('/login/timeout')
      }
    },
    resetState() {
      this.$store.commit('set', ['application', null])
      this.$store.commit('set', ['modal', {}])
      this.$store.commit('set', [
        'auth',
        { userId: this.$store.state.auth.userId, isUserActive: false }
      ])
    }
  },
  render: h => h(App)
}).$mount('#app')
